<!-- 代购买入订单 -->
<script setup>
import tabsView from '@/components/tabsView/index.vue'
import { getModifyBankOrderAPI } from '@/apis/wallet'
import TitleComponent from '@/components/TitleComponent/index.vue'
import { getBehalfUserOrder, cancelOrderAPI, statusOrderAPI, DelayOrderAPI,setChangePayTypeAPI,getLogisticsTrackAPI } from '@/apis/order'
import router from '@/router'
import { onMounted, ref } from 'vue'
import usdPayment from '@/components/usdPayment/index.vue'
// import orderDetails from '@/components/orderDetails/index.vue'
import { useI18n } from 'vue-i18n'
import { formatToLocalTime,countdown,exchangeOrderRate,symbolStatus,fomartPayState ,payState,exchangeOrderTotalRate} from '@/utils/index'
import { useUserStore } from '@/stores/userStore'
import { useCartStore } from '@/stores/cartStore'
const cartStore = useCartStore()
const userStore = useUserStore()
const ipTime = userStore.ipTime;
const { t } = useI18n();
// tab列表
const tabTypes = [
    { id: 1, name: t('number70') },
    { id: 2, name: t('number71') },
    { id: 3, name: t('number72') },
    { id: 6,  name:t('setup630') },
    { id: 4, name: t('number73') },
    { id: 5, name: t('number74') },
]
// 总数量
const total = ref(0)
// 获取订单列表
const orderList = ref([])
const params = reactive({
    fromData: {
        filter_status: '0',
        sell_type: 1,
        page: 1,
        page_size: 5
    }

})

const getOrderList = async () => {
    clearInterval(intervalId.value);
    console.log(params.fromData);
    const res = await getBehalfUserOrder(params.fromData)
    if (res.data.list) {
        let data=res.data.list
       

        data.forEach((group) => {
            // 使用 reduce 计算每个 group 的 items 中的 value 合计
            group.totalValue = group.orders.reduce((sum, item) => 
                sum + parseFloat(exchangeOrderTotalRate(item.price,item.buy_num,userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate)) , 0);
        });
        console.log('数据值',data)
        orderList.value = data
        const timestamp = Math.floor(Date.now() / 1000);
        console.log(timestamp);
        orderList.value.forEach(item=>{
            if(item.expire_time){
                item.expire_time=item.expire_time-timestamp;
                
            }
        })
        if(res.data.list.length==0){
            if(params.fromData.page>1){
                params.fromData.page=params.fromData.page-1
                pageChange(params.fromData.page)
            }
        }
        total.value = res.data.page.total
        startCountdown()
    }
}

const loading = ref(false)
const noMore = computed(() => {
    if (orderList.value) {
        if (orderList.value.length >= total.value) {
            return true;
        } else {
            return false;
        }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        params.fromData.page++
        const res = await getBehalfUserOrder(params.fromData)
        if (res.data.list) {
            let data=res.data.list
       

            data.forEach((group) => {
                // 使用 reduce 计算每个 group 的 items 中的 value 合计
                group.totalValue = group.orders.reduce((sum, item) => 
                    sum + parseFloat(exchangeOrderTotalRate(item.price,item.buy_num,userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate)) , 0);
            });
            orderList.value = [...orderList.value, ...data]
            loading.value = false
        }

    }, 100)
}

// tab切换
const tabChange = (type) => {
    console.log(type);
    if (type == 1) {
        params.fromData.filter_status = 0
        params.fromData.page = 1
    } else if (type == 2) {
        params.fromData.filter_status = 1
        params.fromData.page = 1
    } else if (type == 3) {
        params.fromData.filter_status = 2
        params.fromData.page = 1
    } else if (type == 4) {
        params.fromData.filter_status = 3
        params.fromData.page = 1
    } else if (type == 5) {
        params.fromData.filter_status = 4
        params.fromData.page = 1
    }else if (type == 6) {
        params.fromData.filter_status = 5
        params.fromData.page = 1
    }
   
    clearInterval(intervalId.value);
    getOrderList();
   
}


// 页数切换
const pageChange = (page) => {
    console.log(page);
    params.fromData.page = page
    getOrderList()
}
/**
 * 取消订单
 */
const cancelOrder = (id) => {
    ElMessageBox.confirm(
        t('setup446'),
        t('number99'),
        {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
        }
    )
        .then(async () => {
            console.log('取消')
            const res = await cancelOrderAPI({ order_no: id,order_type:2 })
            if (res.code == 0) {
                ElMessage({ type: 'success', message: t('number92') })
                getOrderList()
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
        })
        .catch(() => {

        })

}
const topUpVisible = ref(false)
const topUpClose = (value) => {
    topUpVisible.value = value
}

const statusOrder = async (id, status, value,order) => {
    

    if (status == 1) {
        if (userStore.userInfo.balance < value) {
            //进入充值
            topUpVisible.value = true
            console.log('账户余额不足')
            return;
        }
    }
    const data = {
        order_no: id,
        status: status,
        // shipping_number:2,
        order_type:2
    }
    const res = await statusOrderAPI(data)
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number93') })
        getOrderList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}

/**
 * 延迟收货
 */
const DelayOrder = async (id) => {
    const res = await DelayOrderAPI({ order_no: id,order_type:2 })
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number94') })
        getOrderList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
/**
 * 钱庄立即支付
 */
const bankOrder = async (id, type) => {
    const res = await getModifyBankOrderAPI({ order_no: id, status: type })
    if (res.code == 0) {
        ElMessage({ type: 'success', message: t('number109') });
        getOrderList()
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
/**
 * 查看订单详情
 * @param no 
 */
const goOrderDetails = (no) => {
    router.push('/orderDetails/' + no+'/2')
}
// 将秒转换为时间字符串
const secondsToTime = (seconds) => {
  const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const minutes = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
  const secondsRemaining = (seconds % 60).toString().padStart(2, '0');
  return `${hours}:${minutes}:${secondsRemaining}`;
};

// 更新倒计时时间
const updateCountdown = () => {
    orderList.value.forEach(item => {
    if (item.expire_time > 0) {
      item.expire_time--;
    } else {
      item.expire_time = 0;
    }
  });
};
const intervalId=ref()
// 启动倒计时
const startCountdown = () => {
    console.log(12)
    intervalId.value = setInterval(() => {
    
    updateCountdown();
  }, 1000);
  console.log('zhi',intervalId)
//   clearInterval(intervalId);
  onBeforeUnmount(() => {
    clearInterval(intervalId);
  });
};
onBeforeUnmount(() => {
    clearInterval(intervalId.value);
});
/**
 * 切换支付方式
 */
 const setChangePayType=async (id)=>{
    // const res = await setChangePayTypeAPI({ order_no: id, bank_order_no:bankId })
    // if (res.code == 0) {
       nextTick(()=>{
        cartStore.order_no_list=[id]
        router.push('/Payment')
       })
    // } else {
    //     ElMessage({ type: 'error', message: res.message })
    // }
}
/**
 * ustd支付
 * @param data 
 */
 const setUstdPayType=(data)=>{
  
  let zhi={pay_result:data}
  console.log(zhi)
  cartStore.usdData=zhi
  console.log(cartStore.usdData)
  router.replace({ path: '/usdPayment' })
   cartStore.usdData.redirect='third'
}
//支付邮费
const Paypostage=(id,status)=>{
    nextTick(()=>{
        cartStore.order_no_list=[id]
        router.push('/Payment/2/'+status)//1.商城平台,2.第三方
    })
}
/**
 * 立即付款
 * orderNo 订单号
 */
const paying=(orderNo)=>{
    cartStore.order_no_list=[orderNo]
     router.push('/Payment')
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    getOrderList()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})
/**
 * 查看商品详情
 */
 const goTheWolfDetails=(form,id)=>{
    // router.push('/detail/'+id)
    router.push({ path: '/externals/'+form+'/'+id}) 
}
/**
 * 判断入库时间
 * value入库时间
 */
const time=(value)=>{
    // 计算 14 天后的时间戳

const futureTimestamp = value + 5 * 24 * 60 * 60 * 1000;

// 获取当前时间戳
const currentTimestamp = Date.now();

// 判断结果
console.log(futureTimestamp > currentTimestamp); // 输出 true 或 false
return futureTimestamp > currentTimestamp;
}
const Logistics=ref([])
const LogisticsModel=ref(false)
/**
 * 查看物流单号
 */
const checkLogistics=async (no)=>{
    const res = await getLogisticsTrackAPI({ logistics_number: no })
    if (res.code == 0) {
        if(res.data.list!=null){
            Logistics.value=res.data.list.reverse();
         console.log(Logistics.value)
        }else{
            Logistics.value=[]
           
        }
        LogisticsModel.value=true;
    
        console.log( LogisticsModel.value)
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
/**
 * 关闭物流窗口
 * @param data 
 */
const LogisticsCancel=(data)=>{
    LogisticsModel.value=data
}
</script>

<template>
     <TitleComponent :url="'/member'" :title="$t('setup456')" v-if="isMobile"></TitleComponent>
    <div class="order">
        <div class="buy-title" v-if="isMobile==false">
            {{ $t('setup456') }}
        </div>
       
        <tabsView :tabsList="tabTypes" @setCheckTabs="tabChange" :bottom="'true'" class="tabsView" v-if="isMobile"></tabsView>
        <tabsView :tabsList="tabTypes" @setCheckTabs="tabChange" :bottom="'false'" class="tabsView" v-else></tabsView>
        <div class="order-container">
            <div class="main-container">
                <div class="holder-container" v-if="orderList.length === 0">
                    <el-empty :description="t('number80')" />
                </div>
                <div v-else>

                    <div class="infinite-list-wrapper" v-if="isMobile == true">
                        <ul v-infinite-scroll="load" class="list" :infinite-scroll-disabled="disabled">
                            <div v-for="order in orderList" :key="order.id" class="listItem">
                                <div class="tophead">
                                    {{ $t('number100') }} : 51shopy
                                    <!-- {{ order.shop_user }} -->
                                </div>
                                <div class="head">
                                    <div style="font-size: 13px;">
                                        <!-- {{ $t('number81') }}： -->
                                        {{ order.order_no }}
                                    </div>
                                </div>
                                <div class="order-item">
                                    <div class="body">
                                        <div class="column goods" v-for="item in order.orders" :key="item.id">
                                            <ul>
                                                <li @click="goTheWolfDetails(order.from,item.product_id)">

                                                    <a class="image" href="javascript:;">
                                                        <img :src="item.cover_url" alt="" />
                                                    </a>
                                                    <div class="info">
                                                        <p class="name ellipsis-2">
                                                            {{ item.product_name }}
                                                        </p>
                                                        <p class="norm">
                                                            {{ item.sku_name}} *{{ item.buy_num }}
                                                        </p>
                                                        <div class="seesaw">
                                                            <div class="price">
                                                                <span class="red" v-if="order.currency==''">{{exchangeOrderRate(item.price,userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate) }}</span> 
                                                                <span class="red" v-else> {{ symbolStatus(order.currency) }}{{ item.price }}</span>
                                                           
                                                            </div>
                                                           
                                                        </div>
                                                    </div>
                                                   

                                                </li>
                                            </ul>
                                        </div>
                                        <div class="StatusTotal flexEnd">
                                            <div class="status">
                                                <span v-if="order?.pay_result?.status&&order.pay_result.status==2">
                                                    {{ $t('setup542') }} &nbsp;&nbsp;
                                                </span>
                                                <span v-else-if="order.status==40">
                                                    {{ $t('setup677') }} &nbsp;&nbsp;
                                                </span>
                                                <span v-else>
                                                    {{ fomartPayState(order.status) }}&nbsp;&nbsp;
                                                </span>
                                            </div>
                                            <div class="Total ">{{ $t('number86') }}：
                                                <span class="red"  v-if="order.currency==''">{{userStore.exchangeRate.symbol }}{{ order.totalValue }}</span>
                                                <span class="red"  v-else>{{symbolStatus(order.currency)}}{{ order.total_price}}</span>
                                
                                            </div>
                                        </div>
                                        <div class="DetailsBUT aboutflex">
                                            <el-popover  placement="bottom"  trigger="click">
                                                <template #reference>
                                                <div>{{ $t('setup450') }}</div>
                                                </template>
                                                <div class="More" @click="goOrderDetails(order.order_no)">
                                                    {{ $t('number88') }}
                                                </div>
                                                <div class="More" v-if="order.status !=30&&order.status !=10&&order.status !=53"
                                                    type="primary" @click="cancelOrder(order.order_no)" size="small" plain>
                                                    {{ $t('number99') }}
                                                    <!-- 取消订单 -->
                                                </div>
                                                <div class="More" v-if="order.status == 53" type="primary" size="small"
                                                    @click="DelayOrder(order.order_no)" plain>
                                                    {{ $t('number98') }}
                                                    <!-- 延迟收货 ？-->
                                                </div>
                                            </el-popover>
                                           
                                            <div class="subBUT aboutflex">
                                                <div class="but HorizontalCenter" v-if="order.status ==53"
                                                    @click="checkLogistics(order.intl_shipping_number)" plain>
                                                    {{$t('setup585')}}<!-- 查看物流 -->
                                                </div>
                                                <div class="but HorizontalCenter" v-if="order.status == 0 && (order.pay_type == 0 ||order.pay_type == 4||order.pay_type == 5||order.pay_type == 8)" type="primary" size="small"
                                                    @click="paying(order.order_no)" plain>
                                                    {{ $t('number96') }}
                                                    <!-- 立即付款 -->
                                                </div>
                                                <div class="but HorizontalCenter" v-if="(order.status==0||order.status==51)  &&order.pay_type==3"
                                                    @click="setUstdPayType(order.pay_result)" size="small" type="primary" plain>
                                                    {{ $t('setup494') }} <!-- 继续支付 -->
                                                </div>
                                                <el-button class="but HorizontalCenter" v-if="order.status==51 &&  (order.pay_type == 0 ||order.pay_type == 4||order.pay_type == 5||order.pay_type == 8)"
                                                    @click="Paypostage(order.order_no,order.status)" size="small" type="primary" plain>
                                                    {{ $t('setup448') }}<!-- 支付邮费 -->
                                                </el-button>
                                                <div class="but HorizontalCenter" v-if="(order.status==0) && (order.pay_type==3||order.pay_type==2)"
                                                @click="setChangePayType(order.order_no)"  size="small" type="primary" plain>
                                                    {{ $t('setup447') }} <!-- 切换支付 -->
                                                </div>
                                                <div class="but HorizontalCenter" v-if="(order.status==51) && (order.pay_type==3||order.pay_type==2)"
                                                @click="Paypostage(order.order_no,order.status)" size="small" type="primary" plain>
                                                {{ $t('setup447') }} <!-- 支付邮费切换支付 -->
                                                </div>

                                                <div class="but HorizontalCenter" v-if="(order.status==0||order.status==51) && order.pay_type==2 && order.pay_result.status==1" type="primary"
                                                @click="bankOrder(order.pay_result.bank_order_no, 2)" size="small" plain>
                                                    <span v-if="order.expire_time!=0"> {{secondsToTime(order.expire_time)}}</span>{{ $t('number108') }}
                                                    <!-- 我已支付 -->
                                                </div>
                                                <div class="but HorizontalCenter" v-if="order.status == 53" type="primary" size="small"
                                                    @click="statusOrder(order.order_no, 30)" plain>
                                                    {{ $t('number97') }}
                                                        <!-- 确认收货 -->
                                                </div>
                                               
                                               
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                        <p v-if="loading" style="text-align: center;">Loading...</p>
                        <p v-if="noMore" style="text-align: center;">No more</p>
                    </div>
                    <div v-else>
                        <div v-for="order in orderList" :key="order.id" style="margin-bottom: 10px;">
                            <!-- <div class="tophead">{{ $t('number100') }}: {{
                                order.shop_user }}</div> -->
                            <!-- 订单列表 -->
                            <div class="head">
                                <div>{{ $t('number81') }}: {{ order.order_no }}<span style="margin-left: 20px;">{{ $t('number82') }}: {{ formatToLocalTime(ipTime, order.created_at*1000) }}</span></div>
                                
                                <div v-if="order.shipping_number">{{ $t('number77') }}:{{ order.shipping_number}}</div>
                              
                            </div>
                            <div style="display: flex;justify-content: space-between;">
                                <div style="display: flex;flex-direction: column;height: auto; border: 1px solid #E5E8EC;">
                                    <div class="order-item" v-for="item in order.orders" :key="item.id" style="flex: 1;">
                                        <div class="body">
                                            <div class="column goods">
                                                <ul>
                                                    <li @click="goTheWolfDetails(order.from,item.product_id)">
                                                        <div class="Product">
                                                            <a class="Productimage" href="javascript:;">
                                                                <img :src="item.cover_url" alt="" />
                                                            </a>
                                                            <div class="info">
                                                                <p class="name ellipsis">
                                                                    {{ item.product_name }}
                                                                </p>
                                                                <p class="skuname">
                                                                    {{ item.sku_name }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="seesaw">
                                                            <div class="price">
                                                                <span class="red" v-if="order.currency==''">{{exchangeOrderRate(item.price,userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate) }}</span> 
                                                                <span class="red" v-else> {{ symbolStatus(order.currency) }}{{ item.price }}</span>
                                                            </div>
                                                            <div class="count"> * {{ item.buy_num }}</div>
                                                        </div>

                                                    </li>
                                                </ul>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="borderDIV" style="width: 110px;">
                                    <div style="padding-top: 10px;">
                                        <p>{{ payState(order.pay_type)}}</p>
                                        <p style="padding: 5px 0;">
                                            <a :href="`${order.telegram}`" target="_blank" rel="nofollow" v-if="order.telegram"
                                                class="button" style="padding: 0 4px;">
                                                <img src="../../../assets/images/telegram.png" style="width: 20px;height: 20px;" alt=""
                                                    srcset="">
                                            </a>
                                            
                                            <a v-if="order.watch_app" :href="`${order.watch_app}`" target="_blank" rel="nofollow" class="button" style="padding: 0 4px;">
                                                    <img src="../../../assets/images/watch.png"
                                                        style="width: 20px;height: 20px;border-radius: 50%;    " alt="" srcset="">
                                            </a>
                                        </p>  
                                    </div>
                                    <div  @click="goOrderDetails(order.order_no)">
                                        <a href="javascript:;" class="green">{{ $t('number85') }}</a>
                                    </div>
                                </div>
                                <div class="borderDIV" style="width: 110px;">
                                   
                                    <p v-if="order?.pay_result?.status&&order.pay_result.status==2">
                                        {{ $t('setup542') }}
                                    </p>
                                    <p v-else-if="order.status==40">
                                                    {{ $t('setup677') }} &nbsp;&nbsp;
                                    </p>
                                    <p v-else>
                                        {{ fomartPayState(order.status) }}

                                    </p>
                                </div>
                                
                                <div class="borderDIV  sum " style="width: 110px;">
                                    <p>{{ $t('number86') }}</p> 
                                    <p class="price"> 
                                        <span v-if="order.currency==''">{{userStore.exchangeRate.symbol }}{{ order.totalValue }}</span> 
                                        <span v-else> {{ symbolStatus(order.currency) }}{{ order.total_price }}</span>
                                    
                                    </p>
                                </div>
                                <div class="borderDIV  butdiv" style="width: 140px;">
                                    <el-button class="but" v-if="order.status == 0 && (order.pay_type == 0 ||order.pay_type == 4||order.pay_type == 5||order.pay_type == 8)"
                                        type="primary" @click="paying(order.order_no)"
                                        size="small" plain>
                                        {{ $t('number96') }} <!-- 立即付款 -->
                                    </el-button>
                                    <el-button class="but" v-if="(order.status==0||order.status==51) && order.pay_type==2 && order.pay_result.status==1" type="primary"
                                        @click="bankOrder(order.pay_result.bank_order_no, 2)" size="small" plain>
                                        <span v-if="order.expire_time!=0">{{secondsToTime(order.expire_time)}} </span>  
                                            {{ $t('number108') }}<!-- 我已支付 -->
                                    </el-button>
                                    <el-button class="but" v-if="order.status == 53" type="primary"
                                        @click="statusOrder(order.order_no, 30)" size="small" plain>
                                        {{ $t('number97') }}<!-- 确认收货 -->
                                    </el-button>
                                    <el-button class="but" v-if="order.status == 53" size="small" type="primary"
                                        @click="DelayOrder(order.order_no)" plain>
                                        {{ $t('number98') }}<!-- 延迟收货? -->
                                    </el-button>
                                  
                                    <el-button class="but" v-if="order.status==51 &&  (order.pay_type == 0 ||order.pay_type == 4||order.pay_type == 5||order.pay_type == 8)"
                                        @click="Paypostage(order.order_no,order.status)" size="small" type="primary" plain>
                                        {{ $t('setup448') }}<!-- 支付邮费 -->
                                    </el-button>
                                    <el-button class="but" v-if="(order.status==0||order.status==51)  &&order.pay_type==3"
                                    @click="setUstdPayType(order.pay_result)" size="small" type="primary" plain>
                                    {{ $t('setup494') }} <!-- 继续支付 -->
                                    </el-button>
                                    <el-button class="but" v-if="(order.status==0) && (order.pay_type==3||order.pay_type==2)"
                                    @click="setChangePayType(order.order_no)" size="small" type="primary" plain>
                                    {{ $t('setup447') }} <!-- 切换支付 -->
                                    </el-button>
                                    <el-button class="but" v-if="(order.status==51) && (order.pay_type==3||order.pay_type==2)"
                                    @click="Paypostage(order.order_no,order.status)" size="small" type="primary" plain>
                                    {{ $t('setup447') }} <!-- 支付邮费切换支付 -->
                                    </el-button>
                                      <!-- {{ order.pay_type==1 积分支付 2 钱庄代付 }} 30  40  10 53  41-->
                                      <el-button class="but" v-if="order.status ==41 ||order.status ==0 || order.status ==20 || ((order.status == 52 ||order.status == 50 ||order.status == 51) && time(order.store_time))"
                                        @click="cancelOrder(order.order_no)" size="small" type="primary" plain>
                                        {{ $t('number99') }}<!-- 取消订单 -->
                                    </el-button>
                                    <el-button class="but" v-if="order.status ==53"
                                        @click="checkLogistics(order.intl_shipping_number)" size="small" type="primary" plain>
                                        {{$t('setup585')}}<!-- 查看物流 -->
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <!-- 分页 -->
                        <div class="pagination-container">
                            <el-pagination :total="total" @current-change="pageChange" :current-page="params.fromData.page"
                                :page-size="params.fromData.page_size" background layout="prev, pager, next" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isMobile == false">
            <topUpView v-if="topUpVisible" @handleClose="topUpClose" :model="topUpVisible"></topUpView>
        </div>
        <div v-else>
            <topUpView v-if="topUpVisible" @handleClose="topUpClose" :model="topUpVisible"></topUpView>
        </div>
        <LogisticsView v-if="LogisticsModel==true" :model="LogisticsModel" :list="Logistics" @cancel="LogisticsCancel"></LogisticsView>
    </div>
</template>

<style scoped lang="scss">
.phone {
    display: none;
}

.pc {
    display: block;
}

.buy-title{
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 18px;
    color: #11192D;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    padding: 30px 20px;
}
.order-container {
    background: #ffffff;
    padding: 0px 20px 20px 20px;
    border-radius: 8px;

    user-select: text;
    .pagination-container {
        display: flex;
        justify-content: center;
    }

    .main-container {
        min-height: calc(100vh - 114px);

        .holder-container {
            // min-height: 500px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
.tophead{
    padding: 10px 24px;
    background: #F3F6F8;
    border-radius: 8px 8px 0px 0px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #666666;
    line-height: 19px;
    text-align: left;
    font-style: normal;
}
.head {
    // height: 50px;
    padding: 18px 24px;
    line-height: 50px;
    // background: #f5f5f5;
    background: #FF9845;
    // padding: 0 20px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    span {
        margin-right: 20px;

        &.down-time {
            margin-right: 0;
            float: right;

            i {
                vertical-align: middle;
                margin-right: 3px;
            }

            b {
                vertical-align: middle;
                font-weight: normal;
            }
        }
    }

    .del {
        margin-right: 0;
        float: right;
        color: #999;
    }
}

.butdiv {
    padding: 16px 11px;
    text-align: end;
    width: 140px;
    .but {
        margin: 5px 0px;
    }
}

.sum {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    text-align: right;
    font-style: normal;
    // text-align: end;
    // padding: 0;
  
    // border-bottom: 1px solid #ebeef5;

}


.borderDIV {
    width: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid #E5E8EC;
    border-right: 1px solid #E5E8EC;
    border-top: 2px solid #E5E8EC;
    align-items: center;
    .green {
                    color: $xtxColor;
                }
}
.price{
    color: red;
}
.order{
    background: #ffffff; 
    border-radius: 8px;
    height: 100%;
    }
    .order-item:last-child {
         border-bottom: none;  /* 移除最后一个div的下边框 */
    }
.order-item {
    height:auto;
    // height: 100%;
    // margin-bottom: 20px;
    // border: 1px solid #E5E8EC;
    flex: 1;
    border-bottom: 1px solid #E5E8EC;
    // height: 100%;

    .body {
        height: 100%;
        display: flex;
        align-items: stretch;

        .column {
            border-left: 1px solid #E5E8EC;;
            text-align: center;
            // padding: 20px;

            >p {
                padding-top: 10px;
            }

            &:first-child {
                border-left: none;
            }

            &.goods {
                height: 100%;
                flex: 1;
                padding: 0;
                align-self: center;

                ul {
                     height: 100%;
                    li {
                        // border-top: 1px solid #E5E8EC;
                         height: 100%;
                        // border-bottom: 1px solid #E5E8EC;;
                        display: flex;
                        align-items: center;

                        &:last-child {
                            // border-bottom: none;
                            // border-top: 1px solid #E5E8EC;
                        }
                       
                        .Product{
                            padding: 20px 0 20px 20px;
                            display: flex;
                            .Productimage {
                                width: 78px;
                                height: 78px;
                                background: #F5F6F8;
                                border-radius: 8px;
                                border: 1px solid #E5E8EC;;

                                img {
                                    border-radius: 8px;
                                    width: 78px;
                                    height: 78px;
                                }
                            }
                            .info {
                                width: 193px;
                                text-align: left;
                                padding: 0 10px;

                                p {
                                    // margin-bottom: 5px;

                                    &.name {
                                        height: 38px;
                                    }
                                    &.skuname{
                                        font-family: MicrosoftYaHei;
                                        font-size: 14px;
                                        color: #666666;
                                        line-height: 19px;
                                        text-align: left;
                                        font-style: normal;
                                    }

                                    &.attr {
                                        color: #999;
                                        font-size: 12px;

                                        span {
                                            margin-right: 5px;
                                        }
                                    }
                                }
                            }
                        }
                       

                        

                        .seesaw {
                            width: 74px;
                            padding: 30px 0 48px;
                            border-left: 1px solid #E5E8EC;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #666666;
                            line-height: 19px;
                            text-align: left;
                            font-style: normal;
                            height: 100%;
                        }

                        // .price {
                        //     // width: 100px;
                        // }

                        // .count {
                        //     // width: 80px;
                        // }
                    }
                }
            }

            .red {
                color: $priceColor;
            }

            &.state {
                width: 120px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .green {
                    color: $xtxColor;
                }
            }

            &.amount {
                width: 200px;
                display: flex;
                flex-direction: column;
                justify-content: center;


            }

            &.action {
                width: 200px;
                display: flex;
                flex-direction: column;



                // a {
                //     display: block;

                //     &:hover {
                //         color: $xtxColor;
                //     }
                // }
            }
        }
    }
}

.address {
    padding: 0 20px;
}

:deep(.el-collapse-item__header) {
    padding: 0px 20px;
}



@media (max-width: 768px) {
    .order{
    background: #f7f7f7; 
    height: 100%;
    }
    .phone {
        display: block;
    }

    .pc {
        display: none;
    }
    .green {
        color: $xtxColor;
    }
    .tabsView{
        margin-top: 45px;
        padding-top: 15px;
    }
    .order-container {
        background: #f7f7f7; 
        // margin-top: 36px;
        // padding: 10px 10px 66px 10px;

       
    }
    .More{
                padding: 5px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
                line-height: 14px;
                text-align: left;
                font-style: normal;
            }
    .infinite-list-wrapper{
        .list{
            .listItem{
                margin-bottom: 15px;
            }
           .tophead{
            background: #FF9845;
            border-radius: 6px 6px 0px 0px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 12px;
            text-align: left;
            font-style: normal;
            padding: 10px 15px;
           } 
           .head{
            padding: 11px 15px;
            background-color: #ffffff;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #333333;
            line-height: 12px;
            text-align: left;
            font-style: normal;
            border-bottom: 1px solid #EEEEEE;
           }
           .order-item {
            background-color: #ffffff;
            height: 100%;
            // box-shadow: 0px 4px 20px 6px rgba(237, 237, 237, 0.75);
            // border-radius: 4px;
            border-end-end-radius: 4px;
            border-end-start-radius: 4px;
            // border-bottom: 4px;
            .body {
                flex-direction: column;

                .goods {
                    // height: 96px;

                    ul li {
                        &:last-child {
                            // border-bottom: none;
                            border-top: 0px solid #E5E8EC;
                        }
                        .image {
                            img {
                                width: 82px;
                                height: 82px;
                                border-radius: 8px;
                                // width: 100%;
                            }
                        }

                        .info {
                            width: calc(100% - 92px);
                            padding-left: 10px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #222222;
                            line-height: 20px;
                            text-align: left;
                            font-style: normal;
                            .norm{
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 400;
                                font-size: 12px;
                                color: #888888;
                                line-height: 17px;
                                text-align: left;
                                font-style: normal;
                                padding-bottom: 11px;
                            }
                            .seesaw{
                            width: 100%;
                            // height: 100%;
                            padding: 0;
                            border-left: 0px solid #E5E8EC;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: flex-start;
                            font-family: MicrosoftYaHei;
                            font-size: 14px;
                            color: #666666;
                            line-height: 19px;
                            text-align: left;
                            font-style: normal;
                            }
                        }
                    }


                }
                .StatusTotal{
                    border-top:1px solid #EEEEEE;
                    padding:  15px;
                    border-bottom:1px solid #EEEEEE;
                    .status{
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #222222;
                        line-height: 12px;
                        text-align: left;
                        font-style: normal; 
                    }
                    .Total{
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #888888;
                        line-height: 14px;
                        text-align: left;
                        font-style: normal; 
                        .red{
                            color: #FF4F00;
                        }
                    }
                }
                .DetailsBUT{
                    padding: 15px;
                    .detail{
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #333333;
                        line-height: 14px;
                        text-align: left;
                        font-style: normal;
                    }
                    
                    .subBUT{
                        .but{
                            height: 28px;
                            background: #F6F6F6;
                            border-radius: 14px; 
                            padding:0 19px ;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #333333;
                            line-height: 14px;
                            text-align: left;
                            font-style: normal;
                            margin: 0 2px;
                        } 
                    }
                    
                }
               

            }
            
            .column {
                border-left: 1px solid transparent;
                padding: 14px 15px;
                width: 100%;
                &.action {
                    width: 100%;


                }

                &.amount {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    padding-right: 20px;

                }

                &.order {
                    color: #909399;
                    display: flex !important;
                    justify-content: center !important;
                    align-items: center !important;

                    .orderitem {
                        width: 100% !important;
                        font-size: 13px !important;
                        padding: 5px 5px !important;
                    }

                    .item {
                        width: 100% !important;

                        display: flex !important;
                        justify-content: space-between;
                    }
                }

                &.action {
                    width: 100% !important;
                    display: flex;
                    flex-direction: row !important;
                    justify-content: flex-end;
                    border-top: 1px solid #f5f5f5;

                    .but {
                        margin: 5px;
                    }
                }
            }
        }
        }
    }

}
</style>